module.exports = __webpack_public_path__ + "img/m-banner-qdqhodgn-ru-RU.a0ed2086.png";